import styled from 'styled-components';
import { FaCheckCircle } from 'react-icons/fa';

export const IconContainer = styled.div`
  display: flex;
  justify-content: space-between;

  & svg {
    border: 1px solid #f2f2f2;
    border-radius: 50%;
    padding: 12px;
    cursor: pointer;
    box-sizing: initial;

    &:hover {
      background-color: #f2f2f2;
    }

    &.active {
      background-color: #f2f2f2;
    }
  }
`;

export const SuccessIcon = styled(FaCheckCircle)`
  color: #4caf50;
  font-size: 5rem;
  margin-bottom: 1rem;
  margin-top: 2rem;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 500;
`;

export const Description = styled.p`
  font-size: 14px;
  margin: 24px 0;
  color: #666;
`;

export const TextArea = styled.textarea`
  margin-top: 24px;
  width: 100%;
  height: 150px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  resize: none;
  font-family: 'Inter', sans-serif;
  font-size: 12px;

  &::placeholder {
    font-size: 12px;
    font-weight: 500;
  }

  &:focus {
    outline: none;
    border: 1px solid #6349ff;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px; 
`;

export const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  font-weight: 500;
  color: #666;
  cursor: pointer;

  &.submit {
    background-color: #6349ff;
    color: white;
    border: 1px solid #6349ff;

    &:hover {
      background-color: #4f36e8;
      border: 1px solid #4f36e8;
    }
  }
`;

export const CharCount = styled.div`
  margin-top: 1px;
  margin-bottom: 16px;
  font-size: 10px;
  text-align: start;
  color: #666;
  font-weight: 500;
`;

export const FeedbackModalContainer = styled.section`
   margin: 24px;
`;

export const SuccessIconContainer = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
text-align: center;

& > p {
  font-size: 14px;
  color: #666;
  margin: 8px 0;
}
`;